import './simplysavoryvalley/style';
import FormStructure from './simplysavoryvalley/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/Dev/web_inquiry/inquiry-renderer/client_forms/includes.js